export function buildHeadersWithWidgetToken(
  widgetToken: string | undefined,
  existingHeaders?: HeadersInit
): Headers {
  const headers = new Headers(existingHeaders);

  if (widgetToken) {
    headers.append('x-widget-token', widgetToken);
  }

  return headers;
}
